import SalesComparisons from "../../pages/file/comparisons/comparisons";
import Details from "../../pages/file/details";

export const fileMenus = [
    {
        menuCode: 'S-DETAILS',
        menuComponent: <Details />
    },
    {
        menuCode: 'S-COM',
        menuComponent: <SalesComparisons />
    },
];